<template>
<v-layout >
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <v-layout v-else column>
        <v-card>
            <v-toolbar color="primary" class="white--text">
                <v-btn icon dark @click="cancelEdit">
                    <v-icon large>close</v-icon>
                </v-btn>
                <v-spacer></v-spacer>
                <v-toolbar-title>Trap Inspection</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon large dark>edit</v-icon>
            </v-toolbar>            
        </v-card>
        <v-form ref="editForm" v-model="editValid">
            <v-card flat>
                <v-layout row wrap pa-2>
                    <v-flex>
                        <label-value :label="'Location'" :value="editItem.LocationName"></label-value>                   
                    </v-flex>
                    <v-flex>
                        <label-value :label="'Inspection Date'" :value="editItem.InspectionDate | formatDateTime"></label-value>
                    </v-flex>
                </v-layout>
                <v-layout row wrap pa-2>
                    <v-flex>
                        <v-textarea box clearable name="notes" label="Inspection Notes" counter="1000" :rules="[rules.maxOneThousandCharacters]" v-model="editItem.InspectionNotes" hint="Inspection Notes"></v-textarea>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-card flat>
                <v-toolbar color="shrink grey darken-1" class="white--text">
                    <v-toolbar-title>Traps</v-toolbar-title>
                </v-toolbar>
            </v-card>        
            <v-card flat>
                <v-layout row wrap pa-1>
                    <v-flex xs12 sm6 md4 lg3 v-for="(trap, index) in editItem.Details" :key="index" pa-1>
                        <trap-inspection-entry :item="trap"></trap-inspection-entry>
                    </v-flex>
                </v-layout>
            </v-card>
            <v-layout wrap class="dialog-action-buttons">
                <v-flex xs12 sm6>
                    <v-btn block color="success" :disabled="!editValid || error != null" :loading="saving" @click="save(editItem)">Save</v-btn>
                </v-flex>
                <v-flex xs12 sm6>
                    <v-btn block color="error" :disabled="saving" @click="cancelEdit">Cancel</v-btn>
                </v-flex>
                <v-flex xs12>
                    <v-alert :value="error != null" outline type="error">
                        {{error}}
                    </v-alert>
                </v-flex>
            </v-layout>
        </v-form>
    </v-layout>
    <yes-no-popup :DisplayDialog="showChangeDialog" :DialogTitle="'Cancel Changes'" :DialogContents="'Are you sure you wish to cancel, any changes made will be lost?'" @No="showChangeDialog = false" @Yes="confirmCancel" />
</v-layout>
</template>

<script>
import TrapInspectionEntry from '@/components/trap/TrapInspectionEntry.vue';
import LabelValue from '@/components/generic/LabelValue.vue';
import validationRules from "@/helpers/validationrules";
import YesNoPopup from '@/components/generic/YesNoPopup.vue';

export default {
    components: {
        TrapInspectionEntry,
        LabelValue,
        YesNoPopup
    },
    props: ['inspection'],
    watch: {
        inspection() {
            this.createEditItem();
        }
    },
    data() {
        return {
            loading: false,
            editValid: true,
            saving: false,
            rules: validationRules.rules,
            showChangeDialog: false,
            editItem: {
                TrapInspectionID: null,
                LocationID: null,
                LocationName: null,
                InspectionDate: null,
                Notes: null,
                Details: []
            }
        };
    },
    computed: {
        error() {
            if (this.editItem.Details.some(d => (d.BugCount != null && d.BugCount !== '') || (d.Notes != null && d.Notes !== ''))) {
                return null;
            }

            return "At least one trap needs a count / notes entry";
        }
    },
    methods: {
        cancelEdit() {
            if (this.isModified(this.editItem, this.inspection)) {
                this.showChangeDialog = true;
            } else {
                this.$emit('cancel');
            }
        },
        save(item) {
            this.$emit('save', item);
        },
        createEditItem() {
            if (this.inspection) {
                this.editItem = JSON.parse(JSON.stringify(this.inspection));
            } else {
                this.editItem = { Details: [] };
            }
        },
        isModified(original, updated) {            
            return JSON.stringify(original) != JSON.stringify(updated);
        },
        confirmCancel() {
            this.showChangeDialog = false;
            this.$emit('cancel');
        }
    }
}
</script>
